import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ContainerComponent } from '../../components/container/container.component';

@Component({
    selector: 'rl-onboarding-container-component',
    encapsulation: ViewEncapsulation.None,
    templateUrl: 'onboarding-container.component.html',
    styleUrls: ['onboarding-container.component.scss'],
    imports: [RouterOutlet]
})
export class OnboardingContainerComponent extends ContainerComponent {}
